import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

/** Título de página (24px) + subtítulo à esquerda; ações à direita. */
export const PageHeader = ({
  titulo,
  subtitulo,
  acoes,
  className,
}: {
  titulo: ReactNode;
  subtitulo?: ReactNode;
  acoes?: ReactNode;
  className?: string;
}) => (
  <div className={cn("flex flex-wrap items-end justify-between gap-4", className)}>
    <div className="flex min-w-0 flex-col gap-1">
      <h2 className="text-2xl font-semibold tracking-titulo">{titulo}</h2>
      {subtitulo && <p className="text-sm text-muted-foreground">{subtitulo}</p>}
    </div>
    {acoes && <div className="flex flex-wrap items-center gap-2">{acoes}</div>}
  </div>
);

/**
 * Cabeçalho das telas de detalhe: "← {lista}", título de 22px e badge de status;
 * à direita, valor ou ações.
 */
export const DetailHeader = ({
  voltar,
  titulo,
  status,
  subtitulo,
  acoes,
  className,
}: {
  voltar: { to: string; label: string };
  titulo: ReactNode;
  status?: ReactNode;
  subtitulo?: ReactNode;
  acoes?: ReactNode;
  className?: string;
}) => (
  <div className={cn("flex flex-col gap-3", className)}>
    <Button variant="ghost" size="sm" asChild className="-ml-2 h-8 w-fit px-2 text-muted-foreground">
      <Link to={voltar.to}>
        <ArrowLeft />
        {voltar.label}
      </Link>
    </Button>
    <div className="flex flex-wrap items-start justify-between gap-4">
      <div className="flex min-w-0 flex-col gap-1">
        <div className="flex flex-wrap items-center gap-3">
          <h2 className="text-[22px] font-semibold tracking-titulo">{titulo}</h2>
          {status}
        </div>
        {subtitulo && <p className="text-sm text-muted-foreground">{subtitulo}</p>}
      </div>
      {acoes && <div className="flex flex-wrap items-center gap-2">{acoes}</div>}
    </div>
  </div>
);
